// extracted by mini-css-extract-plugin
module.exports = {"AuthForm":"AuthForm_AuthForm__9T19f","Title":"AuthForm_Title__1UAiC","SubmitButtonContainer":"AuthForm_SubmitButtonContainer__fAcg6","AuthSpinner":"AuthForm_AuthSpinner__15XW3"};